// 固定根元素字体大小 + 动态 CSS 变量单位
const FIXED_FONT_SIZE = 16 // 固定根元素字体大小为 16px

export function setFixedRem() {
    // 直接设置固定的根元素字体大小（永远不变）
    document.documentElement.style.fontSize = FIXED_FONT_SIZE + 'px'
}

/**
 * 计算并设置动态单位变量（基于视口尺寸）
 */
export function setDynamicUnit() {
    const viewportHeight = window.innerHeight
    const viewportWidth = window.innerWidth

    // 参考视口尺寸（在此尺寸下，--unit = 1px）
    const REFERENCE_HEIGHT = 1080
    // const REFERENCE_WIDTH = 1920
    const REFERENCE_WIDTH = 2560

    // 键盘原始设计高度
    const KEYBOARD_HEIGHT = 384.16

    // 键盘最多占视口高度的比例（可调整）
    const MAX_HEIGHT_RATIO = 0.7  // 70% 的视口高度

    // 方案3: 宽度自由缩放，但高度不能超过限制
    const scaleByWidth = viewportWidth / REFERENCE_WIDTH

    // 计算高度限制：键盘实际高度不能超过 viewportHeight * MAX_HEIGHT_RATIO
    const maxAllowedHeight = viewportHeight * MAX_HEIGHT_RATIO
    const scaleByHeightLimit = maxAllowedHeight / KEYBOARD_HEIGHT

    // 取较小值，确保不超过高度限制
    let scale = Math.min(scaleByWidth, scaleByHeightLimit)

    // 限制缩放范围：提高最小缩放比例，保持键盘在小屏幕下可读性
    scale = Math.max(0.75, Math.min(scale, 1.5))  // 最小 0.75x，最大 1.5x

    // 计算动态单位值（px）
    const unitValue = scale

    // 设置 CSS 变量
    const root = document.documentElement
    root.style.setProperty('--unit', `${unitValue}px`)
    root.style.setProperty('--scale', scale)

    // 计算实际键盘尺寸
    const actualKeyboardHeight = KEYBOARD_HEIGHT * scale
    const heightPercentage = (actualKeyboardHeight / viewportHeight) * 100

    console.log(`[动态单位] 详细信息:
  视口尺寸: ${viewportWidth} x ${viewportHeight}
  参考尺寸: ${REFERENCE_WIDTH} x ${REFERENCE_HEIGHT}
  html font-size: ${FIXED_FONT_SIZE}px (固定不变)

  宽度缩放: ${scaleByWidth.toFixed(3)} (${viewportWidth} / ${REFERENCE_WIDTH})
  高度限制: ${scaleByHeightLimit.toFixed(3)} (键盘最多占 ${(MAX_HEIGHT_RATIO * 100).toFixed(0)}% 高度)
  最终缩放: ${scale.toFixed(3)} (取较小值)

  --unit: ${unitValue.toFixed(3)}px
  键盘实际尺寸: ${(1024 * scale).toFixed(2)} x ${actualKeyboardHeight.toFixed(2)}px
  占视口高度: ${heightPercentage.toFixed(1)}%`)
}

// 初始化固定 rem
export function initFixedRem() {
    // 页面加载时设置
    setFixedRem()
    setDynamicUnit()

    // 窗口大小改变时重新计算动态单位
    let resizeTimer = null
    window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer)
        resizeTimer = setTimeout(() => {
            setDynamicUnit()
        }, 100)
    })

    // 页面显示时重新设置
    window.addEventListener('pageshow', function (e) {
        if (e.persisted) {
            setFixedRem()
            setDynamicUnit()
        }
    })

    // 屏幕方向改变时重新计算
    window.addEventListener('orientationchange', function () {
        setTimeout(() => {
            setDynamicUnit()
        }, 100)
    })

    console.log('[固定 rem + 动态单位] 初始化完成')
}

// 导出默认函数
export default initFixedRem